import { ModalProps } from '@vtex/admin-ui'
import { ConfirmationModal } from '../../../ConfirmationModal'
import { messages } from './messages'
import styles from './styles'

type Props = {
  state: ModalProps['state']
  onConfirm: () => void
  onCancel: () => void
}

export function BudgetNoAuthorizedWrite(props: Props) {
  const { state, onConfirm, onCancel } = props
  return (
    <ConfirmationModal
      state={state}
      onConfirm={onConfirm}
      onCancel={onCancel}
      className={styles.container}
      messages={messages}
      variant="secondary"
    />
  )
}
